import {
  ColumnProps as RAColumnProps,
  Column as RACColumn,
  composeRenderProps,
} from "react-aria-components";
import clsx from "clsx";
import {
  columnStyles,
  endAlignedColumn,
  centerAlignedColumn,
} from "./tables.css";
import { Align } from "./types";

interface ColumnProps extends RAColumnProps {
  /**
   * Logical text alignment for the column header.
   * Use "start" by default and "end" for numeric headers.
   */
  align?: Align;
}

const alignStyles: Record<Align, string> = {
  start: columnStyles,
  end: endAlignedColumn,
  center: centerAlignedColumn,
};

const Column = ({
  children,
  align = "start",
  className,
  ...props
}: ColumnProps) => (
  <RACColumn
    // Keep our alignment class, then merge any className the caller passes.
    // Caller className can be a string or a function—useful for styling sortable columns
    // (e.g. adding cursor:pointer when allowsSorting is true, or highlighting based on sortDescriptor state).
    className={composeRenderProps(className, (resolvedClassName) =>
      clsx(alignStyles[align], resolvedClassName),
    )}
    {...props}
  >
    {children}
  </RACColumn>
);

export default Column;
